/**
 * Date types for tasks
 */
export enum DateType {
  Date = 1, // Just the date (no time component)
  DateTime = 2, // Full date and time
}

/**
 * Convert DateType enum to string representation
 */
export function dateTypeToString(
  dateType: DateType | null | undefined,
): 'date' | 'datetime' | null {
  if (dateType === null || dateType === undefined) {
    return null
  }

  switch (dateType) {
    case DateType.Date:
      return 'date'
    case DateType.DateTime:
      return 'datetime'
    default:
      return null
  }
}

/**
 * Convert string representation to DateType enum
 */
export function stringToDateType(
  dateTypeString: string | null | undefined,
): DateType | null {
  if (!dateTypeString) {
    return null
  }

  switch (dateTypeString.toLowerCase()) {
    case 'date':
      return DateType.Date
    case 'datetime':
      return DateType.DateTime
    default:
      return null
  }
}
